/**
 * Runtime image CDN identifiers shared with the backend wire contract.
 * Must be kept in sync with `rust/server/src/api/structs.rs`.
 */
export const DISPLAY_IMAGE_CDN = {
  Amazon: 'amazon',
  Walmart: 'walmart',
  Shopify: 'shopify',
  Static: 'static',
} as const;

/** Identifies the provider-specific transformation contract for a display image. */
export type DisplayImageCdn = (typeof DISPLAY_IMAGE_CDN)[keyof typeof DISPLAY_IMAGE_CDN];

/** Describes an image URL and the provider contract used to size it. */
export interface DisplayImage {
  /** Source URL supplied by the backend. */
  url: string;
  /** Provider whose URL transformation rules apply to the source. */
  cdn: DisplayImageCdn;
}
